import { createContext, useContext } from 'react';

const ViewerSettingsContext = createContext(null);

export function ViewerSettingsProvider({ value, children }) {
  return (
    <ViewerSettingsContext.Provider value={value}>
      {children}
    </ViewerSettingsContext.Provider>
  );
}

export function useViewerSettingsContext() {
  const ctx = useContext(ViewerSettingsContext);
  if (!ctx) throw new Error('useViewerSettingsContext must be used inside ViewerSettingsProvider');
  return ctx;
}
